export const regionTypeHeaderData = [
    {
        field: 'RowId',
        headerName: 'Row Id',
        width: '80',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'RegionType',
        headerName: 'BP Region Type',
        width: '150',
        hideInTable: false,
        isDisabled: false,
        sortable: true

    },
    {
        field: 'Status',
        headerName: 'Status',
        width: '85',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedBy',
        headerName: 'Created By',
        width: '110',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedDate',
        headerName: 'Created Date',
        width: '140',
        hideInTable: false,
        isDisabled: false,
        type: 'date'
    },
    {
        field: 'ModifiedBy',
        headerName: 'Modified By',
        width: '110',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'LastModifiedDate',
        headerName: 'Last Modified Date',
        width: '140',
        hideInTable: false,
        isDisabled: false,
        type: 'date'
    },
    {
        field: 'Comments',
        headerName: 'Comments',
        width: '350',
        hideInTable: false,
        isDisabled: false,
    },
];

export const regionTypeInitialState = {
    RowId: '',
    RegionType: '',
    Status: 'Inactive',
    CreatedBy: '',
    CreatedDate: '',
    ModifiedBy: '',
    LastModifiedDate: '',
    Comments: ''
};

export const regionTypeSearchState = {
    RowId: '',
    RegionType: '',
    Status: '',
    CreatedBy: '',
    CreatedDate: '',
    ModifiedBy: '',
    LastModifiedDate: '',
    Comments: ''
};

export const regionTypeApiEndpoint = {
    read: 'ADMIN_GetRegionTypeLkup'
};
